import { RegisteredId } from '@luminovo/commons';

export const topBoxId: RegisteredId = 'bom_importer/table_header';
